<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="'/Project/Bench/Onsite'"
                            >Onsite Case</router-link
                        >
                        / Ce Close Case
                    </h1>
                </v-col>
                <v-col cols="6" class="text-right"> </v-col>
            </v-row>
        </v-container>

        <v-row>
            <v-col cols="12" sm="10" md="8">
                <v-form method="post" id="nativeForm" v-model="valid">
                    <v-card>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="headline"
                                    >Case ID : {{ data_main.case_id }}
                                </v-list-item-title>
                                <br />
                                <b style="color:#2d4b77" class="mb-5 mt-1">
                                    {{ data_main.case_title }}
                                </b>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        v-if="
                                            data_main.product_group !=
                                                'Printing'
                                        "
                                    >
                                        <v-radio-group
                                            v-model="form_1.fid"
                                            :rules="fidR"
                                            required
                                            row
                                        >
                                            <v-radio
                                                label="มี UEFI"
                                                value="Y"
                                            ></v-radio>
                                            <v-radio
                                                label="ไม่มี UEFI"
                                                value="N"
                                            ></v-radio> </v-radio-group
                                    ></v-col>
                                    <v-col
                                        cols="6"
                                        class="mar-t-10"
                                        v-if="
                                            form_1.fid != '' &&
                                                form_1.fid != null
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            v-if="form_1.fid === 'Y'"
                                            dense
                                            label="ระบุ UEFI"
                                            v-model="form_1.fid_text"
                                            :maxlength="27"
                                            :counter="27"
                                            @keyup="checkfid_text()"
                                            :rules="fid_textR"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            outlined
                                            v-if="form_1.fid === 'N'"
                                            dense
                                            label="ระบุเหตุผลไม่มี UEFI"
                                            v-model="form_1.fid_text"
                                            :rules="fid_textRR"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="mar-t-10"
                                        v-if="
                                            data_main.product_group ==
                                                'Printing'
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            label="Print Count"
                                            v-model="form_1.printcount"
                                            :rules="printcountR"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="mar-t-20">
                                    <v-col cols="12">
                                        <!-- @keyup="uppercase()" -->
                                        <v-textarea
                                            outlined
                                            label="Solution.."
                                            background-color="#FFFF"
                                            rows="3"
                                            :rules="solutionR"
                                            v-model="form_1.solution"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <!-- justify="center" -->
                                <div v-if="data_main.project_name == 'SRFR'">
                                    <v-row
                                        v-for="(n, index) in form_1.part_srfr"
                                        :key="index"
                                        class="mar-t-20"
                                    >
                                        <v-col cols="12" class="mb-5">
                                            <b style="color:#2d4b77">
                                                Part {{ index + 1 }}
                                            </b>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            class="mar-t-20"
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                label="Part no"
                                                v-model="
                                                    form_1.part_srfr[index]
                                                        .part_no
                                                "
                                                :rules="part_noR"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            md="7"
                                            class="mar-t-20"
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                label="Part Description"
                                                v-model="
                                                    form_1.part_srfr[index]
                                                        .part_description
                                                "
                                                :rules="part_descriptionR"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="1"
                                            class="text-left mar-t-20"
                                        >
                                            <v-btn
                                                v-if="index + 1 === num"
                                                fab
                                                x-small
                                                color="blue accent-1"
                                                @click="plus()"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                fab
                                                x-small
                                                color="red lighten-1"
                                                @click="del(index)"
                                            >
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            class="mar-t-20"
                                        >
                                            <v-select
                                                dense
                                                outlined
                                                :items="[
                                                    'Good',
                                                    'Defective',
                                                    'DOA',
                                                ]"
                                                label="Status part"
                                                v-model="
                                                    form_1.part_srfr[index]
                                                        .part_status
                                                "
                                                :rules="part_statusR"
                                                required
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            class="mar-t-20"
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                label="CT เก่า"
                                                v-model="
                                                    form_1.part_srfr[index]
                                                        .ct_old
                                                "
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                            class="mar-t-20"
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                label="CT ใหม่"
                                                v-model="
                                                    form_1.part_srfr[index]
                                                        .ct_new
                                                "
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row
                                    class="mar-t-20"
                                    v-for="(row_part, nums) in data_main.parts"
                                    :key="nums"
                                >
                                    <v-col cols="12" md="6">
                                        <v-chip dense>
                                            <strong>{{
                                                row_part.part_name
                                            }}</strong>
                                            <span
                                                class="ml-2 font-weight-light text-lowercase"
                                            >
                                                <label
                                                    style="font-weight:400;"
                                                    >{{
                                                        row_part.ponumber
                                                    }}</label
                                                >
                                                <label>
                                                    {{
                                                        row_part.part_description
                                                    }}</label
                                                >
                                            </span>
                                        </v-chip>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-select
                                            dense
                                            outlined
                                            :items="
                                                row_part.status != 'Back Order'
                                                    ? part_item
                                                    : part_backorder_item
                                            "
                                            item-text="text"
                                            item-value="id"
                                            label="Status part"
                                            v-model="
                                                form_1.part[
                                                    'P' + row_part.part_issue_id
                                                ]
                                            "
                                            :rules="part_issue_idR"
                                            required
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="mar-t-20 fix-flex-end-row"
                                        v-if="
                                            form_1.part[
                                                'P' + row_part.part_issue_id
                                            ] === 'Bad' &&
                                                (data_main.project_name !=
                                                    'SRFR' ||
                                                    (data_main.project_name ===
                                                        'SRFR' &&
                                                        row_part.inv_status !=
                                                            'stock'))
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            label="CT เก่า"
                                            v-model="
                                                form_1.ct_old[
                                                    'CTO' +
                                                        row_part.part_issue_id
                                                ]
                                            "
                                        ></v-text-field>

                                        <!-- <v-speed-dial
                                            class="ml-1"
                                            v-model="
                                                chk_bracode[
                                                    'FAB_CT_OLD' +
                                                        row_part.part_issue_id
                                                ]
                                            "
                                            :direction="direction"
                                            transition="slide-y-reverse-transition"
                                        >
                                            <template v-slot:activator>
                                                <v-btn
                                                    @click="
                                                        chk_bracode[
                                                            'CT_OLD' +
                                                                row_part.part_issue_id
                                                        ] = false
                                                    "
                                                    v-model="
                                                        chk_bracode[
                                                            'FAB_CT_OLD' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                    :color="
                                                        chk_bracode[
                                                            'CT_OLD' +
                                                                row_part.part_issue_id
                                                        ] === true ||
                                                        chk_bracode[
                                                            'CT_OLD_IMG' +
                                                                row_part.part_issue_id
                                                        ] === true
                                                            ? 'green accent-3'
                                                            : 'white'
                                                    "
                                                    dark
                                                    small
                                                    fab
                                                >
                                                    <v-icon
                                                        v-if="
                                                            chk_bracode[
                                                                'FAB_CT_OLD' +
                                                                    row_part.part_issue_id
                                                            ]
                                                        "
                                                        color="blue-grey darken-1"
                                                        >mdi-close</v-icon
                                                    >
                                                    <v-icon
                                                        v-else
                                                        color="light-blue darken-4"
                                                        >mdi-barcode-scan</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <v-btn
                                                fab
                                                dark
                                                small
                                                color="teal"
                                                @click="
                                                    open_barcode_ct(
                                                        'old',
                                                        row_part.part_issue_id,
                                                        'img'
                                                    )
                                                "
                                            >
                                                <v-icon>mdi-image</v-icon>
                                            </v-btn>
                                            <v-btn
                                                fab
                                                dark
                                                small
                                                color="cyan"
                                                @click="
                                                    open_barcode_ct(
                                                        'old',
                                                        row_part.part_issue_id,
                                                        'scan'
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    >mdi-barcode-scan</v-icon
                                                >
                                            </v-btn>
                                        </v-speed-dial> -->
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="mar-t-20 fix-flex-end-row"
                                        v-if="
                                            form_1.part[
                                                'P' + row_part.part_issue_id
                                            ] === 'Bad' &&
                                                (data_main.project_name !=
                                                    'SRFR' ||
                                                    (data_main.project_name ===
                                                        'SRFR' &&
                                                        row_part.inv_status !=
                                                            'stock'))
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            label="CT ใหม่"
                                            v-model="
                                                form_1.ct_new[
                                                    'CTN' +
                                                        row_part.part_issue_id
                                                ]
                                            "
                                        ></v-text-field>
                                        <!-- :rules="ct_newR" -->
                                        <!-- <v-speed-dial
                                            class="ml-1"
                                            v-model="
                                                chk_bracode[
                                                    'FAB_CT_NEW' +
                                                        row_part.part_issue_id
                                                ]
                                            "
                                            :direction="direction"
                                            transition="slide-y-reverse-transition"
                                        >
                                            <template v-slot:activator>
                                                <v-btn
                                                    @click="
                                                        chk_bracode[
                                                            'CT_NEW' +
                                                                row_part.part_issue_id
                                                        ] = false
                                                    "
                                                    v-model="
                                                        chk_bracode[
                                                            'FAB_CT_NEW' +
                                                                row_part.part_issue_id
                                                        ]
                                                    "
                                                    :color="
                                                        chk_bracode[
                                                            'CT_NEW' +
                                                                row_part.part_issue_id
                                                        ] === true ||
                                                        chk_bracode[
                                                            'CT_NEW_IMG' +
                                                                row_part.part_issue_id
                                                        ] === true
                                                            ? 'green accent-3'
                                                            : 'white'
                                                    "
                                                    dark
                                                    small
                                                    fab
                                                >
                                                    <v-icon
                                                        v-if="
                                                            chk_bracode[
                                                                'FAB_CT_NEW' +
                                                                    row_part.part_issue_id
                                                            ]
                                                        "
                                                        color="blue-grey darken-1"
                                                        >mdi-close</v-icon
                                                    >
                                                    <v-icon
                                                        v-else
                                                        color="light-blue darken-4"
                                                        >mdi-barcode-scan</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <v-btn
                                                fab
                                                dark
                                                small
                                                color="teal"
                                                @click="
                                                    open_barcode_ct(
                                                        'new',
                                                        row_part.part_issue_id,
                                                        'img'
                                                    )
                                                "
                                            >
                                                <v-icon>mdi-image</v-icon>
                                            </v-btn>
                                            <v-btn
                                                fab
                                                dark
                                                small
                                                color="cyan"
                                                @click="
                                                    open_barcode_ct(
                                                        'new',
                                                        row_part.part_issue_id,
                                                        'scan'
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    >mdi-barcode-scan</v-icon
                                                >
                                            </v-btn>
                                        </v-speed-dial> -->
                                    </v-col>

                                    <!-- Start StreamBarcodeReader -->
                                    <div
                                        v-if="
                                            chk_bracode[
                                                'CT_OLD' +
                                                    row_part.part_issue_id
                                            ] === true
                                        "
                                        class="no-pd mb-4 mar-t-10"
                                    >
                                        <StreamBarcodeReader
                                            @decode="on_ct_old_barcode"
                                            @loaded="onLoaded"
                                        ></StreamBarcodeReader>
                                    </div>
                                    <div
                                        v-if="
                                            chk_bracode[
                                                'CT_NEW' +
                                                    row_part.part_issue_id
                                            ] === true
                                        "
                                        class="no-pd mb-4 mar-t-10"
                                    >
                                        <StreamBarcodeReader
                                            @decode="on_ct_new_barcode"
                                            @loaded="onLoaded"
                                        ></StreamBarcodeReader>
                                    </div>
                                    <!-- End StreamBarcodeReader -->

                                    <!-- Start ImageBarcodeReader -->
                                    <div
                                        v-if="
                                            chk_bracode[
                                                'CT_OLD_IMG' +
                                                    row_part.part_issue_id
                                            ] === true
                                        "
                                        class="no-pd mb-4 mar-t-10 ml-4"
                                    >
                                        <ImageBarcodeReader
                                            class="mb-3"
                                            @decode="on_ct_old_barcode"
                                            @error="onError"
                                        ></ImageBarcodeReader>
                                    </div>
                                    <div
                                        v-if="
                                            chk_bracode[
                                                'CT_NEW_IMG' +
                                                    row_part.part_issue_id
                                            ] === true
                                        "
                                        class="no-pd mb-4 mar-t-10 ml-4"
                                    >
                                        <ImageBarcodeReader
                                            class="mb-3"
                                            @decode="on_ct_new_barcode"
                                            @error="onError"
                                        ></ImageBarcodeReader>
                                    </div>
                                </v-row>
                                <v-row class="mar-t-10">
                                    <!-- <v-col cols="6">
                    <v-chip color="amber">
                      <b
                        >Cus. Email :
                        {{ data_main.customer_email }}
                      </b></v-chip
                    >
                  </v-col> -->
                                    <v-col cols="6">
                                        <!-- <v-text-field
                      outlined
                      dense
                      label="Email"
                      background-color="#FFFF"
                      v-model="form_1.email"
                    ></v-text-field> -->
                                    </v-col>
                                </v-row>

                                <v-row class="mar-t-10">
                                    <v-col cols="6">
                                        <!-- <v-menu
                      ref="menu1"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form_1.kcp_pickup_date"
                          label="Kcp Pickup Date"
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="form_1.kcp_pickup_date"
                        no-title
                        @input="menu = false"
                        @change="change_text_autolog()"
                      ></v-date-picker>
                    </v-menu> -->
                                    </v-col>
                                    <v-col cols="6">
                                        <!-- <v-textarea
                      outlined
                      v-model="text_copy"
                      label="Auto Log..."
                    ></v-textarea> -->

                                        <!-- <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          style="margin-left:-15px; margin-top:-90px; "
                          small
                          v-on="on"
                          color="blue lighten-1"
                          fab
                          @click="doCopyCase()"
                        >
                          <v-icon color="white">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy Log</span>
                    </v-tooltip> -->
                                    </v-col>
                                </v-row>
                                <v-row class="mar-t-20">
                                    <!-- <v-col cols="6" md="4">
                                         <div
                      id="my-strictly-unique-vue-upload-multiple-image"
                      style="text-align: center;"
                    >
                      <vue-upload-multiple-image
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        @edit-image="editImage"
                        @data-change="dataChange"
                        dragText="UPLOAD"
                        browseText="CSO"
                        primaryText="cso image"
                        markIsPrimaryText="จัดลำดับรูปภาพ"
                        idUpload="myIdUpload1"
                        editUpload="myIdEdit1"
                        :maxImage="50"
                      ></vue-upload-multiple-image>
                    </div> 
                                    </v-col>-->

                                    <!-- <v-col
                                        cols="6"
                                        md="4"
                                        v-if="
                                            data_main.product_group !=
                                                'Printing'
                                        "
                                    >
                                         <div id="2" style="text-align: center;">
                      <vue-upload-multiple-image
                        @upload-success="uploadImageSuccess2"
                        @before-remove="beforeRemove2"
                        @edit-image="editImage2"
                        @data-change="dataChange2"
                        dragText="UPLOAD"
                        browseText="
                                                UEFI
                                            "
                        primaryText="uefi image"
                        markIsPrimaryText="จัดลำดับรูปภาพ"
                        idUpload="myIdUpload2"
                        editUpload="myIdEdit2"
                        :maxImage="50"
                      ></vue-upload-multiple-image>
                    </div> 
                                    </v-col>-->
                                    <v-col cols="6" md="4">
                                        <div id="2" style="text-align: center;">
                                            <vue-upload-multiple-image
                                                @upload-success="
                                                    uploadImageSuccess3
                                                "
                                                @before-remove="beforeRemove3"
                                                @edit-image="editImage3"
                                                @data-change="dataChange3"
                                                dragText="UPLOAD"
                                                browseText="ATTACH"
                                                primaryText="attach image"
                                                markIsPrimaryText="จัดลำดับรูปภาพ"
                                                idUpload="myIdUpload3"
                                                editUpload="myIdEdit3"
                                                :maxImage="50"
                                            ></vue-upload-multiple-image>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="12" class="mar-t-10">
                                        <v-btn
                                            color="success"
                                            block
                                            @click="save_close_case()"
                                            :disabled="!valid"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import VueRouter from "vue-router"
import { mapState, mapMutations } from "vuex"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import { StreamBarcodeReader, ImageBarcodeReader } from "vue-barcode-reader"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.form_1.maincase_id = this.$route.params.maincase_id
        this.get_data()
    },
    components: {
        VueUploadMultipleImage,
        StreamBarcodeReader,
        ImageBarcodeReader,
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            this.mutateIsLoading(0)
            await axios
                .get(url + "get-case-bkk/" + this.form_1.maincase_id, this.tk)
                .then((response) => {
                    // console.log(response)
                    this.mutateIsLoading()
                    this.data_main = response.data
                    this.chk_pj = response.data.project_name
                    this.text_copy = response.data.autolog

                    this.data_main.parts.map((each) => {
                        this.$set(
                            this.form_1.part,
                            "P" + each.part_issue_id,
                            ""
                        )

                        this.$set(
                            this.chk_bracode,
                            "BARCODE" + each.part_issue_id,
                            false
                        )

                        this.$set(
                            this.chk_bracode,
                            "BARCODE_IMG" + each.part_issue_id,
                            false
                        )

                        this.$set(
                            this.chk_bracode,
                            "CT_OLD" + each.part_issue_id,
                            false
                        )
                        this.$set(
                            this.chk_bracode,
                            "CT_NEW" + each.part_issue_id,
                            false
                        )

                        this.$set(
                            this.chk_bracode,
                            "CT_OLD_IMG" + each.part_issue_id,
                            false
                        )
                        this.$set(
                            this.chk_bracode,
                            "CT_NEW_IMG" + each.part_issue_id,
                            false
                        )

                        this.$set(
                            this.chk_bracode,
                            "FAB_CT_OLD" + each.part_issue_id,
                            false
                        )
                        this.$set(
                            this.chk_bracode,
                            "FAB_CT_NEW" + each.part_issue_id,
                            false
                        )

                        this.$set(
                            this.form_1.ct_old,
                            "CTO" + each.part_issue_id,
                            ""
                        )

                        if (each.ct_new === null) {
                            this.$set(
                                this.form_1.ct_new,
                                "CTN" + each.part_issue_id,
                                ""
                            )
                        } else {
                            this.$set(
                                this.form_1.ct_new,
                                "CTN" + each.part_issue_id,
                                each.ct_new
                            )
                        }
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async checkfid_text() {
            if (this.form_1.fid === "Y" && this.form_1.fid_text.length === 27) {
                await axios
                    .post(
                        "https://eas-api.hpcloud.hp.com/v1/DecodeFailureIds/",
                        {
                            LanguageId: "en-US",
                            FailureIds: [
                                {
                                    FailureId: this.form_1.fid_text,
                                },
                            ],
                        }
                    )
                    .then((response) => {
                        if (response.data.DecodeFailureIds[0].Valid === false) {
                            this.form_1.fid_text = ""
                            this.$swal("FID invalid! Please try again.", {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        } else if (
                            response.data.DecodeFailureIds[0].Valid === true
                        ) {
                            this.$swal("FID Valid.", {
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })
                        }
                    })
            }
        },
        uppercase() {
            this.form_1.solution = this.form_1.solution.toUpperCase()
        },
        open_barcode_ct(statuss, part_issue_id, type) {
            for (let key in this.chk_bracode) {
                if (statuss === "old" && key != "FAB_CT_OLD" + part_issue_id) {
                    this.chk_bracode[key] = false
                } else if (
                    statuss === "new" &&
                    key != "FAB_CT_NEW" + part_issue_id
                ) {
                    this.chk_bracode[key] = false
                }
            }

            if (statuss === "old") {
                if (type === "img") {
                    this.chk_bracode["CT_OLD_IMG" + part_issue_id] = !this
                        .chk_bracode["CT_OLD_IMG" + part_issue_id]
                    if (
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] === true
                    ) {
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                    }
                } else {
                    this.chk_bracode["CT_OLD" + part_issue_id] = !this
                        .chk_bracode["CT_OLD" + part_issue_id]
                    if (this.chk_bracode["CT_OLD" + part_issue_id] === true) {
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] === false
                    }
                }
            } else {
                if (type === "img") {
                    this.chk_bracode["CT_NEW_IMG" + part_issue_id] = !this
                        .chk_bracode["CT_NEW_IMG" + part_issue_id]
                    if (
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] === true
                    ) {
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW" + part_issue_id] = false
                    }
                } else {
                    this.chk_bracode["CT_NEW" + part_issue_id] = !this
                        .chk_bracode["CT_NEW" + part_issue_id]
                    if (this.chk_bracode["CT_NEW" + part_issue_id] === true) {
                        this.chk_bracode["CT_OLD" + part_issue_id] = false
                        this.chk_bracode["CT_NEW_IMG" + part_issue_id] = false
                        this.chk_bracode["CT_OLD_IMG" + part_issue_id] = false
                    }
                }
            }

            if (
                this.chk_bracode["CT_OLD" + part_issue_id] === true ||
                this.chk_bracode["CT_NEW" + part_issue_id] === true ||
                this.chk_bracode["CT_OLD_IMG" + part_issue_id] === true ||
                this.chk_bracode["CT_NEW_IMG" + part_issue_id] === true
            ) {
                this.chk_active_ct_bracode = part_issue_id
            } else {
                this.chk_active_ct_bracode = ""
            }
        },
        onError(result) {
            // console.log(result, "-- Error")
        },
        on_ct_old_barcode(result) {
            if (result != "" || result != undefined) {
                this.form_1.ct_old["CTO" + this.chk_active_ct_bracode] = result
                this.chk_bracode["CT_OLD" + this.chk_active_ct_bracode] = false
                this.chk_bracode[
                    "CT_OLD_IMG" + this.chk_active_ct_bracode
                ] = false
            }
        },
        on_ct_new_barcode(result) {
            if (result != "" || result != undefined) {
                this.form_1.ct_new["CTN" + this.chk_active_ct_bracode] = result
                this.chk_bracode["CT_NEW" + this.chk_active_ct_bracode] = false
                this.chk_bracode[
                    "CT_NEW_IMG" + this.chk_active_ct_bracode
                ] = false
            }
        },
        onLoaded(result) {
            // console.log(result)
        },
        uploadImageSuccess(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.cso = fileList
        },
        beforeRemove(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        uploadImageSuccess2(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.uefi = fileList
        },
        beforeRemove2(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage2(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        uploadImageSuccess3(formData, index, fileList) {
            // console.log("data", formData, index, fileList)

            this.form_1.attach = fileList
        },
        beforeRemove3(index, done, fileList) {
            // console.log("index", index, fileList)
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage3(formData, index, fileList) {
            // console.log("edit data", formData, index, fileList)
        },
        dataChange() {},
        dataChange2() {},
        dataChange3() {},

        async save_close_case() {
            this.mutateIsLoading()
            let formData = new FormData()
            formData.append("part", JSON.stringify(this.form_1.part))
            formData.append("maincase_id", this.form_1.maincase_id)
            formData.append("auto_log", this.text_copy)
            formData.append("kcp_pickup_date", this.kcp_pickup_date)
            formData.append("email", this.form_1.email)
            formData.append("solution", this.form_1.solution)
            formData.append("fid", this.form_1.fid)
            formData.append("fid_text", this.form_1.fid_text)
            formData.append("printcount", this.form_1.printcount)
            formData.append("ct_old", JSON.stringify(this.form_1.ct_old))
            formData.append("ct_new", JSON.stringify(this.form_1.ct_new))
            formData.append("part_srfr", JSON.stringify(this.form_1.part_srfr))

            if (undefined !== this.form_1.cso && this.form_1.cso.length) {
                for (let i = 0; i < this.form_1.cso.length; i++) {
                    let img_cso = resizebase64(
                        this.form_1.cso[i].path,
                        1000,
                        1000
                    )
                    formData.append(`cso[${i}]`, img_cso)
                }
            }
            if (undefined !== this.form_1.uefi && this.form_1.uefi.length) {
                for (let i = 0; i < this.form_1.uefi.length; i++) {
                    let img_uefi = resizebase64(
                        this.form_1.uefi[i].path,
                        750,
                        750
                    )
                    formData.append(`uefi[${i}]`, img_uefi)
                }
            }
            if (undefined !== this.form_1.attach && this.form_1.attach.length) {
                let size_attach = 0
                this.chk_pj == "MPS"
                    ? (size_attach = 1000)
                    : (size_attach = 750)
                for (let i = 0; i < this.form_1.attach.length; i++) {
                    let img_attach = resizebase64(
                        this.form_1.attach[i].path,
                        750,
                        750
                    )
                    formData.append(`attach[${i}]`, img_attach)
                }
            }

            await axios
                .post(url + "ce-close-case-bkk", formData, this.tk)
                .then((response) => {
                    // console.log(response)
                    this.mutatesnackbar()
                    this.mutateIsLoading()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                    this.$root.$router.push({
                        path: "/Project/Bench/Onsite",
                    })
                })
                .catch(function(error) {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        doCopyCase: function() {
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
        change_text_autolog() {
            this.text_copy =
                this.data_main.autolog + " " + this.form_1.kcp_pickup_date
        },
        plus() {
            this.num = this.num + 1
            this.form_1.part_srfr.push({
                part_no: null,
                part_description: null,
                part_status: null,
                ct_new: null,
                ct_old: null,
            })
        },
        del(num) {
            // const items = ["a", "b", "c", "d", "e", "f"]
            // const valueToRemove = "c"
            // const filteredItems = items.filter((item) => item !== valueToRemove)

            // const items = ["a", "b", "c", "d", "e", "f"]
            // const valueToRemove = "c"
            // const filteredItems = this.form_1.part_srfr.filter((item) => item !== valueToRemove)

            // ["a", "b", "d", "e", "f"]

            this.form_1.part_srfr.splice(num, 1)
            // console.log(this.form_1.part_srfr)
            this.num -= 1
        },
    },
    data() {
        return {
            valid: false,
            menu: false,
            tk: null,
            text_copy: null,
            direction: "left",
            data_main: [],
            chk_bracode: {},
            form_1: {
                maincase_id: null,
                solution: "",
                part: {},
                ct_old: {},
                ct_new: {},
                cso: [],
                uefi: [],
                attach: [],
                fid_text: "",
                kcp_pickup_date: null,
                part_srfr: [
                    {
                        part_no: null,
                        part_description: null,
                        part_status: null,
                        ct_new: null,
                        ct_old: null,
                    },
                ],
            },
            part_item: [
                {
                    id: "Bad",
                    text: "ใช้ Part (73)",
                },
                {
                    id: "Good",
                    text: "ไม่ใช้ Part (72)",
                },
                {
                    id: "DOA",
                    text: "Part เสีย ทำคืน DOA (55)",
                },
                {
                    id: "Same Item",
                    text: "วาง Same Item",
                },
                {
                    id: "Pending",
                    text: "ยังไม่คืน Part ถือไว้ใช้ในซับต่อไป",
                },
            ],
            part_backorder_item: [
                {
                    id: "Cancel",
                    text: "ไม่ใช้ Part",
                },
                {
                    id: "Pending",
                    text: "ต้องใช้ Part / รอ Part",
                },
            ],
            fidR: [(v) => !!v || "FID Status is required"],
            fid_textR: [
                (v) => !!v || "FID Text is required",
                (v) => v.length === 27 || "FID must be less than 27 characters",
            ],
            fid_textRR: [(v) => !!v || "FID Remark  is required"],
            printcountR: [(v) => !!v || "print count  is required"],
            solutionR: [(v) => !!v || "Solution is required"],
            part_issue_idR: [(v) => !!v || "Part is required"],
            part_noR: [(v) => !!v || "part no is required"],
            part_statusR: [(v) => !!v || "part status is required"],
            part_descriptionR: [(v) => !!v || "part description is required"],
            num: 1,
        }
    },
}
</script>
<style scoped>
.no-pd-1 {
    margin-top: -17px;
}
.div-scoll {
    /* position: fixed; */
    overflow: auto;
    width: 100%;
    height: 228px;
    background-color: #c2eafd;
}
.drag-text {
    /* color: rgb(66, 97, 235) !important; */
    font-weight: bold !important;
    font-size: 14px !important;
}
.browse-text {
    color: rgb(66, 97, 235) !important;
    font-weight: bold !important;
    font-size: 22px !important;
}
.clear-btn {
    margin-top: -25px !important;
}
.fix-png-a {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 20px;
}
.v-speed-dial {
    position: absolute !important;
}

.v-btn--floating {
    position: relative !important;
}
</style>
